import styled from 'styled-components'

import { COLORS } from 'consts/colors'
import { TABLET_SIZE_BREAKPOINT } from 'consts'

export const ActionButtons = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  white-space: nowrap;
  @media (max-width: ${TABLET_SIZE_BREAKPOINT}px) {
    padding-left: 2px;
    gap: 2px;
  }
`

export const Divider = styled.div`
  width: 1px;
  height: 24px;
  background: ${COLORS.borderColor};
`
